//Parroquias Falcon
const munAcosta = [
  'San Juan De Los Cayos',
  'Capadare',
  'La Pastora',
  'Libertador',
];
const munBolivarFalcon = ['San Luis', 'Aracua', 'La Peña '];
const munBuchivacoa = [
  'Capatárida',
  'Bariro',
  'Borojó',
  'Guajiro ',
  'sequence',
  'Zazárida',
];
const munCaciqueManaure = ['Cacique Manaure'];
const munCarirubana = ['Carirubana', 'Norte', 'Punta Cardón', 'Santa Ana'];
const munColina = [
  'La Vela De Coro',
  'Acurigua',
  'Guaibacoa',
  'Las Calderas',
  'Macoruca',
];
const munDabajuro = ['Dabajuro'];
const munDemocracia = [
  'Pedregal',
  'Agua Clara',
  'Avaria',
  'Piedra Grande',
  'Purureche',
];
const munFalcon = [
  'Pueblo Nuevo',
  'Adícora',
  'Baraived',
  'Buena Vista',
  'Jadacaquiva',
  'Moruy',
  'Adaure',
  'El Hato',
  'El Vínculo',
];
const munFederacion = [
  'Churuguara',
  'Agua Larga',
  'El Paují',
  'Independencia',
  'Mapararí',
];
const munJacura = ['Jacura', 'Agua Linda', 'Araurima'];
const munLosTaques = ['LosTaques', 'Judibana'];
const munMauroa = ['Mene de Mauroa', 'Casigua', 'San Félix'];
const munMirandaFalcon = [
  'San Antonio',
  'San Gabriel',
  'Santa Ana',
  'Guzmán Guillermo',
  'Mitare',
  'Río Seco ',
  'Sabaneta',
];
const munMonseñorIturriza = [
  'Chichiriviche',
  'Boca De Tocuyo',
  'Tocuyo De La Costa',
];
const munPalmasola = ['Palmasola'];
const munPetit = ['Cabure', 'Colina', 'Curimagua'];
const munPirituFalcon = ['Píritu', 'San José De La Costa'];
const munSanFrancisco = ['San Francisco'];
const munSilva = ['Tucacas', 'Boca De Aroa'];
const munSucreFalcon = ['Sucre', 'Pecaya'];
const munTocopero = ['Tocópero'];
const munUnión = ['Santa Cruz De Bucaral', 'El Charal', 'Las Vegas Del Tuy'];
const munUrumaco = ['Urumaco', 'Bruzual'];
const munZamoraFalcon = [
  'Puerto Cumarebo',
  'La Ciénega',
  'La Soledad',
  'Pueblo Cumarebo',
  'Zazárida',
];

export const esFalcon = [
  {
    municipio: 'Acosta',
    parroquias: munAcosta,
  },
  {
    municipio: 'Bolívar Falcon',
    parroquias: munBolivarFalcon,
  },
  {
    municipio: 'Buchivacoa',
    parroquias: munBuchivacoa,
  },
  {
    municipio: 'Cacique Manaure',
    parroquias: munCaciqueManaure,
  },
  {
    municipio: 'Carirubana',
    parroquias: munCarirubana,
  },
  {
    municipio: 'Colina',
    parroquias: munColina,
  },
  {
    municipio: 'Dabajuro',
    parroquias: munDabajuro,
  },
  {
    municipio: 'Democracia',
    parroquias: munDemocracia,
  },
  {
    municipio: 'Falcón',
    parroquias: munFalcon,
  },
  {
    municipio: 'Federación',
    parroquias: munFederacion,
  },
  {
    municipio: 'Jacura',
    parroquias: munJacura,
  },
  {
    municipio: 'Los Taques',
    parroquias: munLosTaques,
  },
  {
    municipio: 'Mauroa',
    parroquias: munMauroa,
  },
  {
    municipio: 'Miranda',
    parroquias: munMirandaFalcon,
  },
  {
    municipio: 'Monseñor Iturriza',
    parroquias: munMonseñorIturriza,
  },
  {
    municipio: 'Palmasola',
    parroquias: munPalmasola,
  },
  {
    municipio: 'Petit',
    parroquias: munPetit,
  },
  {
    municipio: 'Piritu',
    parroquias: munPirituFalcon,
  },
  {
    municipio: 'San Francisco',
    parroquias: munSanFrancisco,
  },
  {
    municipio: 'Silva',
    parroquias: munSilva,
  },
  {
    municipio: 'Sucre',
    parroquias: munSucreFalcon,
  },
  {
    municipio: 'Tocópero',
    parroquias: munTocopero,
  },
  {
    municipio: 'Unión',
    parroquias: munUnión,
  },
  {
    municipio: 'Urumaco',
    parroquias: munUrumaco,
  },
  {
    municipio: 'Zamora',
    parroquias: munZamoraFalcon,
  },
];
